export default {"src":"/_next/static/media/minus-disabled.d49dd195.svg","height":32,"width":18,"blurWidth":0,"blurHeight":0};